const part = [
    {
        path: 'user-management-list',
        name: 'user-management-list',
        meta: {
            icon: 'md-people',
            title: '用户管理',
            notCache: true,
            access: ['S'],
            items: [
            ]
        },
        component: () => import('@/view/system-management/user-management/user-list')
    }
];

export default part;
